import {camelCaseObjectKeys} from '../../../api/helpers'
import {getJwt} from '../../../auth'
import SERVICES from '../../../config/services'

export const fetchResponse = async <T>(path: string): Promise<T> => {
  const res = await fetch(`${SERVICES.TBT_API_URL}${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `jwt ${getJwt()}`,
    },
  })
  if (!res.ok) {
    throw new Error(`Network error ${res.status}: ${res.statusText}`)
  }
  return camelCaseObjectKeys(await res.json()) as Promise<T>
}

export const deleteResponse = async (path: string, body: unknown): Promise<Response> => {
  try {
    const res = await fetch(`${SERVICES.TBT_API_URL}${path}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `jwt ${getJwt()}`,
      },
      body: JSON.stringify(body),
    })

    if (!res.ok) {
      const error = {
        message: `Network error ${res.status}: ${res.statusText}`,
        code: res.status,
      }

      return Promise.reject(error)
    }

    return Promise.resolve(res.json())
  } catch (error) {
    console.error(error)

    return Promise.reject(error)
  }
}
